export class HealthNetworkPlan {
    public HealthNetworkCode: string;
    public HealthNetworkPlanDesc: string;
    public HealthNetworkPlanCode: string;
    public HealthNetworkName: string;
    public HealthNetworkPlanPhone: string;
    public HealthNetworkPlanDisplayText: string;
    public IncludeFlag: string;
}
